import {PropsWithChildren} from "react";

interface LoadingScreenProps {
    textContent?: string;
    warning?: string | null;
    fullscreen?: boolean;
}

const LoadingScreen = ({textContent, warning, fullscreen = true, children}: PropsWithChildren<LoadingScreenProps>) => {
    return (
        <div className={fullscreen
            ? "fixed inset-0 z-50 flex items-center justify-center bg-background"
            : "flex min-h-64 w-full items-center justify-center bg-background"
        }>
            <div className="flex flex-col items-center gap-4">
                {/* Spinner */}
                <div className="relative w-12 h-12">
                    <div className="absolute inset-0 rounded-full border-4 border-muted"></div>
                    <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-primary animate-spin"></div>
                </div>

                {/* Loading text */}
                {(textContent !== undefined || children === undefined) && <p className="text-sm text-muted-foreground font-medium">{textContent ?? "Loading..."}</p>}

                {/* Retry warning */}
                {warning && (
                    <div className="flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-700 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-400">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
                            <path d="M12 9v4"/>
                            <path d="M12 17h.01"/>
                        </svg>
                        <span>{warning}</span>
                    </div>
                )}

                {children}
            </div>
        </div>
    )
}

export default LoadingScreen
